// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ModeType } from 'src/app/enums/mode-type.enum';
import { RegionType } from 'src/app/enums/region-type.enum';

/*
export const environment = {
  production: false,
  accessKeyId: 'AKIARX5G5EFCDZAFNCGI',
  secretAccessKey: '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',
  parameterSSM: '/TrayLogistics/UI/EnvironmentVariables/Staging',
  mode: ModeType.Staging
};*/

export const environment = {
  configurationData: [],
  mode: ModeType.Staging,
  production: false,
  US: {
    userPoolId: 'us-east-1_k8qFPPquE',
    region: RegionType.USA,
    regionName: 'United States of America',
    clientId: '',
    appClients: [
      {
        id: 'NW4xazdtZm9xbmlrZzY1bWowMmVycGViNw==',
        urlOmni: 'https://identity.api.pat.cbord.com',
        urlTLMiddleware: 'https://stg.api.traylogistics.cbord.com',
      },
    ],
  },
  Aus: {
    userPoolId: 'ap-southeast-2_6Vv452OQI',
    region: RegionType.AUS,
    regionName: 'Australia',
    clientId: '',
    appClients: [
      {
        id: 'M28ybWs0dXZkZWU1YW12aDZkbjFucmExb3M=',
        urlOmni: 'https://au.pat.identity.cbord.com',
        urlTLMiddleware: 'https://au.stg.api.traylogistics.cbord.com',
      },
    ],
  },
  accessKeyId: '',
  secretAccessKey: '',
  parameterSSM: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
